import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ybehrszmmscgqylkwjpz.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InliZWhyc3ptbXNjZ3F5bGt3anB6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA5NzcyODYsImV4cCI6MjA2NjU1MzI4Nn0.IbojP3o87O6Xtj5AFm1hp7-2EvZXHZxQXUl_iSvzrFs';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);